// extracted by mini-css-extract-plugin
module.exports = {"grid":"Marker_grid__1C2w0","marker":"Marker_marker__2UEV1","text":"Marker_text__3iQQY","text--normal":"Marker_text--normal__31XRB","text--large":"Marker_text--large__xZXl8"};